module.exports = __webpack_public_path__ + "bdbe575153be2b49ef42c06e9f15888c.pdf";